"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import React from "react";
import { WaveLeaderboardDrop } from "./WaveLeaderboardDrop";
import { WaveLeaderboardEmptyState } from "./WaveLeaderboardEmptyState";
import { WaveLeaderboardLoading } from "./WaveLeaderboardLoading";
import { WaveLeaderboardLoadingBar } from "./WaveLeaderboardLoadingBar";
interface WaveLeaderboardDropsProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly onCreateDrop?: (() => void) | undefined;
  readonly curatedByGroupId?: string | undefined;
  readonly minPrice?: number | undefined;
  readonly maxPrice?: number | undefined;
  readonly priceCurrency?: string | undefined;
}
export const WaveLeaderboardDrops: React.FC<WaveLeaderboardDropsProps> = t0 => {
  const $ = _c(31);
  const {
    wave,
    sort,
    onDropClick,
    onCreateDrop,
    curatedByGroupId,
    minPrice,
    maxPrice,
    priceCurrency
  } = t0;
  let t1;
  if ($[0] !== curatedByGroupId || $[1] !== maxPrice || $[2] !== minPrice || $[3] !== priceCurrency || $[4] !== sort || $[5] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort,
      curatedByGroupId,
      minPrice,
      maxPrice,
      priceCurrency
    };
    $[0] = curatedByGroupId;
    $[1] = maxPrice;
    $[2] = minPrice;
    $[3] = priceCurrency;
    $[4] = sort;
    $[5] = wave.id;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  let t2;
  if ($[7] !== fetchNextPage || $[8] !== hasNextPage || $[9] !== isFetching || $[10] !== isFetchingNextPage) {
    t2 = async () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        await fetchNextPage();
      }
    };
    $[7] = fetchNextPage;
    $[8] = hasNextPage;
    $[9] = isFetching;
    $[10] = isFetchingNextPage;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const intersectionElementRef = useIntersectionObserver(t2);
  if (isFetching && drops.length === 0) {
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <WaveLeaderboardLoading />;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  if (drops.length === 0) {
    let t3;
    if ($[13] !== onCreateDrop || $[14] !== wave) {
      t3 = <WaveLeaderboardEmptyState onCreateDrop={onCreateDrop} wave={wave} />;
      $[13] = onCreateDrop;
      $[14] = wave;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    return t3;
  }
  let t3;
  if ($[16] !== drops || $[17] !== onDropClick || $[18] !== wave) {
    let t4;
    if ($[20] !== onDropClick || $[21] !== wave) {
      t4 = drop => <WaveLeaderboardDrop key={drop.id} drop={drop} wave={wave} onDropClick={onDropClick} />;
      $[20] = onDropClick;
      $[21] = wave;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    t3 = drops.map(t4);
    $[16] = drops;
    $[17] = onDropClick;
    $[18] = wave;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[23] !== isFetchingNextPage) {
    t4 = isFetchingNextPage && <WaveLeaderboardLoadingBar />;
    $[23] = isFetchingNextPage;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== intersectionElementRef) {
    t5 = <div ref={intersectionElementRef} />;
    $[25] = intersectionElementRef;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t3 || $[28] !== t4 || $[29] !== t5) {
    t6 = <div className="tw-space-y-4">{t3}{t4}{t5}</div>;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
};